export default __webpack_public_path__ + "d141746f54bb4ef7284e33116e6b8d1e.svg";